
import { Provider } from 'react-redux';
import { Route, Routes } from 'react-router-dom';
import NavBar from './components/Navbar/NavBar';
import './main.css';
import BlogsPage from './pages/BlogsPage';
import SingleBlogPage from './pages/SingleBlogPage';
import { store } from './redux/app/store';

function App() {
  return (
    <Provider store={store}>
    <NavBar/>
    <Routes>
      <Route path='/' element={<BlogsPage/>}/>
      <Route path='post/:postId' element={<SingleBlogPage/>}/>
    </Routes>
    </Provider>
  );
}

export default App;
